import { forwardRef, Ref, useEffect, useState } from "react";
import Navigator from "../../models/navigator";
import ProjectInfo from "../../models/projectInfo";
import Settings from "../../models/settings";
import TableMode from "../../models/tableMode";
import TableFullData from "./TableFullData";
import TableOld from "./old/TableOld";
import TableVirtualized from "./TableVirtualized";
import tableService from "../../services/tableService";

export interface TableRef {
  refresh: () => void;
}

interface Props {
  navigator: Navigator;
  project: ProjectInfo;
  settings: Settings;
  //children: React.ReactNode;
}

const Table = forwardRef((props: Props, tableRef: Ref<TableRef>) => {
  const { navigator, project, settings } = props;

  const autoRowCount = 30000;

  const [tableMode, setTableMode] = useState<TableMode>(TableMode.Auto);

  useEffect(() => {
    const init = async () => {
      if (project.tableMode === TableMode.Auto) {
        const { data: tableRowsCount } = await tableService.getTableRowsCount(
          project.idProject,
          []
        );

        console.log("table-auto-rowCount", tableRowsCount);

        if (tableRowsCount < autoRowCount) {
          setTableMode(TableMode.FullData);
        } else {
          setTableMode(TableMode.Virtualized);
        }
      } else {
        setTableMode(project.tableMode);
      }
    };

    init();
  }, [project]);

  if (tableMode === TableMode.FullData) {
    return (
      <TableFullData
        ref={tableRef}
        navigator={navigator}
        project={project}
        settings={settings}
      ></TableFullData>
    );
  } else if (tableMode === TableMode.Virtualized) {
    return (
      <TableVirtualized
        ref={tableRef}
        navigator={navigator}
        project={project}
        settings={settings}
      ></TableVirtualized>
    );
  } else if (tableMode === TableMode.OldTable) {
    return (
      <TableOld
        ref={tableRef}
        navigator={navigator}
        project={project}
        settings={settings}
      ></TableOld>
    );
  }

  return <div />;
});

export default Table;
